<template>
  <base-modal
      :icon="icon"
      :title="title">
    <div class="content">
      <div
          v-if="message"
          class="message"
          v-html="message"/>
      <base-input
          ref="input"
          v-model="value"
          type="text"
          :placeholder="placeholder"
          @keypress.enter="onSubmit(value)"/>
    </div>
    <template #footer>
      <base-button
          v-for="(button, i) in buttons"
          :key="i"
          :text="button.text"
          @click="button.func(value)"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseInput from '@/components/core/BaseInput.vue';
import BaseModal from './BaseModal.vue';

export default {
  name: 'TextInputModal',
  components: {
    BaseButton,
    BaseInput,
    BaseModal,
  },
  props: {
    icon: String,
    title: String,
    message: String,
    placeholder: String,
    buttons: Array,
    onSubmit: Function,
  },
  data() {
    return {
      value: '',
    };
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.625rem;

  .message {
    margin-bottom: 1rem;
    text-align: center;
  }

  input {
    width: 20rem;
  }
}
</style>
